import { render, staticRenderFns } from "./FaqsList.vue?vue&type=template&id=9098c99a&scoped=true"
import script from "./FaqsList.vue?vue&type=script&lang=js"
export * from "./FaqsList.vue?vue&type=script&lang=js"
import style0 from "./FaqsList.vue?vue&type=style&index=0&id=9098c99a&prod&lang=scss&scoped=true"
import style1 from "./FaqsList.vue?vue&type=style&index=1&id=9098c99a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9098c99a",
  null
  
)

export default component.exports